/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RebaselinePlanRequest
 */
export interface RebaselinePlanRequest {
    /**
     * 
     * @type {Date}
     * @memberof RebaselinePlanRequest
     */
    anchorDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof RebaselinePlanRequest
     */
    shiftInitiativeMilestones?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RebaselinePlanRequest
     */
    shiftInitiativeStartDate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RebaselinePlanRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the RebaselinePlanRequest interface.
 */
export function instanceOfRebaselinePlanRequest(value: object): value is RebaselinePlanRequest {
    if (!('anchorDate' in value) || value['anchorDate'] === undefined) return false;
    return true;
}

export function RebaselinePlanRequestFromJSON(json: any): RebaselinePlanRequest {
    return RebaselinePlanRequestFromJSONTyped(json, false);
}

export function RebaselinePlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RebaselinePlanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'anchorDate': (new Date(json['anchorDate'])),
        'shiftInitiativeMilestones': json['shiftInitiativeMilestones'] == null ? undefined : json['shiftInitiativeMilestones'],
        'shiftInitiativeStartDate': json['shiftInitiativeStartDate'] == null ? undefined : json['shiftInitiativeStartDate'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function RebaselinePlanRequestToJSON(json: any): RebaselinePlanRequest {
    return RebaselinePlanRequestToJSONTyped(json, false);
}

export function RebaselinePlanRequestToJSONTyped(value?: RebaselinePlanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'anchorDate': ((value['anchorDate']).toISOString().substring(0,10)),
        'shiftInitiativeMilestones': value['shiftInitiativeMilestones'],
        'shiftInitiativeStartDate': value['shiftInitiativeStartDate'],
        'effectTenantId': value['effectTenantId'],
    };
}

